import React, { FC } from 'react';
import clsx from 'clsx';
import { Text, IconButton, useMediaQuery, Theme, useTheme } from '@maas-components/core';
import { Options, SetOptions } from '../types';
import useStyles from './styles';

export interface ToolbarProps {
    enableColorDark?: boolean;
    title: string;
    icon: React.ReactElement;
    options: Options;
    setOptions: SetOptions;
}

const Toolbar: FC<ToolbarProps> = (props) => {
    const theme: Theme = useTheme();

    const { enableColorDark, title, icon, options, setOptions } = props;

    const { isOpen } = options;

    const mode = enableColorDark ? 'dark' : theme.palette.type;

    const classes = useStyles({ mode });

    const isDownMD = useMediaQuery((theme: Theme) => theme.breakpoints.down(1324));

    const handleToggleNavigation = () => {
        setOptions({
            ...options,
            isOpen: !isOpen,
            isOpenFromMenu: true,
        });
    };

    const cssBar = clsx(classes.root, {
        [classes.rootOpen]: isOpen,
        [classes.rootClose]: !isOpen,
    });

    const cssIcon = clsx(classes.icon, {
        [classes.iconOpen]: isOpen,
        [classes.iconClosed]: !isOpen,
    });

    return (
        <div className={cssBar}>
            <IconButton disableFocusRipple disableRipple onClick={handleToggleNavigation} className={cssIcon}>
                {icon}
            </IconButton>
            {isDownMD ? <Text fontSize="small">{title}</Text> : null}
        </div>
    );
};

export default Toolbar;
